import { action } from "satcheljs";
import type { MailboxInfo } from "owa-client-types";

export interface CloseAddinPaneActionMessage {
    mailboxInfo: MailboxInfo;
    targetWindow: Window;
    isNewFlexPaneOpened: boolean;
}

const closeAddinPane: (mailboxInfo: MailboxInfo, targetWindow: Window, isNewFlexPaneOpened?: boolean) => CloseAddinPaneActionMessage = action("closeAddinPane", (mailboxInfo: MailboxInfo, targetWindow: Window, isNewFlexPaneOpened: boolean = false): CloseAddinPaneActionMessage => ({
    mailboxInfo,
    targetWindow,
    isNewFlexPaneOpened,
}));
export default closeAddinPane;
